<template>
    <ui-PanelOverlay panel="config" :id="`componet_${_uid}`" :show="show" :loading="loading">
        <template v-slot:menuBar>
            <PanelMixinBack></PanelMixinBack>
        </template>
        <template v-slot:body v-if="device">
            <SpaceMenu
                v-if="show"
                :location="location"
                :loading.sync="loading"
                :name="device.name"
                :edition="true"
                :select="true"
                :active="device.space_id"
                @optionsClick="changeSpace($event.id)"
            >
                <template v-slot:config>
                    <FormMixinInput
                        :data="{ model, errors }"
                        :label="$dicc.spaces.name"
                        property="name"
                        type="text"
                        @keyup.enter="save"
                    ></FormMixinInput>
                    <div class="richMenu__actions">
                        <a class="btn btn--simple" style="margin-right:auto" @click="$refs.removeDevice.open()">
                            {{ $dicc.delete }}
                        </a>
                        <a class="btn btn--simple" @click="save">{{ $dicc.confirm }}</a>
                    </div>
                </template>
            </SpaceMenu>
            <ui-Modal ref="removeDevice" :closeText="$dicc.close">
                <template v-slot:head>
                    <p>{{ $dicc.settingsDevicePanel.alertConfirmTitle }}</p>
                </template>
                <template v-slot:body>
                    <p>{{ $dicc.settingsDevicePanel.alertConfirmDescription }}</p>
                </template>
                <template v-slot:actions>
                    <a class="btn btn--simple" @click="remove">{{ $dicc.delete }}</a>
                </template>
            </ui-Modal>
        </template>
    </ui-PanelOverlay>
</template>

<script>
    import SpaceMenu from '../components/SpaceMenu';
    import { PanelMixin } from '../mixins/PanelMixin';
    import { FormMixin } from '../mixins/FormMixin';

    export default {
        name: 'SettingsDevicePanel',
        mixins: [PanelMixin, FormMixin],
        components: { SpaceMenu },
        props: {
            device: Object,
            location: Object,
        },
        data() {
            return {
                type: 'device',
            };
        },
        methods: {
            init() {
                this.$set(this, 'model', {
                    ...this.device,
                });
            },

            save() {
                this.loading++;

                this.$api.updateDevice(
                    {
                        ...this.device,
                        name: this.model.name,
                    },
                    (response) => {
                        this.device.name = response.entity.name;

                        this.$toast({
                            message: this.$dicc.settingsDevicePanel.updated,
                            container: `#componet_${this._uid}`,
                            type: 'is-success',
                        });
                    },
                    (error) => this.showError(error, `#componet_${this._uid}`),
                    () => this.loading--
                );
            },

            remove() {
                this.loading++;
                this.$refs.removeDevice.close();

                this.$api.deleteDevice(
                    this.device,
                    () => {
                        this.$toast({
                            message: this.$dicc.settingsDevicePanel.deleted,
                            container: `#body`,
                            type: 'is-success',
                        });

                        this.$emit('update:show', false);
                        this.$emit('deleteDevice');
                    },
                    (error) => this.showError(error, `#componet_${this._uid}`),
                    () => this.loading--
                );
            },

            changeSpace: function(space) {
                this.loading++;

                this.$api.updateDevice(
                    {
                        ...this.device,
                        space_id: space,
                    },
                    (response) => {
                        this.device.space_id = response.entity.space_id;

                        this.$toast({
                            message: this.$dicc.settingsDevicePanel.updated,
                            container: `#componet_${this._uid}`,
                            type: 'is-success',
                        });
                        this.$emit('updateDevice');
                    },
                    (error) => this.showError(error, `#componet_${this._uid}`),
                    () => this.loading--
                );
            },
        },
        watch: {
            show: {
                immediate: true,
                handler(val) {
                    if (val) this.init();
                },
            },
            'device.reference': {
                immediate: true,
                handler() {
                    this.init();
                },
            },
            'device.installation_ref': {
                immediate: true,
                handler() {
                    this.init();
                },
            },
        },
    };
</script>
